import { render, staticRenderFns } from "./leaderTodo.vue?vue&type=template&id=ef2d0db4&scoped=true&"
import script from "./leaderTodo.vue?vue&type=script&lang=js&"
export * from "./leaderTodo.vue?vue&type=script&lang=js&"
import style0 from "./leaderTodo.vue?vue&type=style&index=0&id=ef2d0db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2d0db4",
  null
  
)

export default component.exports